<div>
  <div class="flex items-center gap-3 mb-6">
    <div class="flex items-center justify-center w-10 h-10 rounded-lg bg-primary-100 dark:bg-primary-900/30">
      <i class="pi pi-user text-primary-600 dark:text-primary-400"></i>
    </div>
    <h3 class="text-xl font-semibold text-gray-900 dark:text-gray-100">{{ 'profile.edit.title' | translate }}</h3>
  </div>
  <div [formGroup]="form" class="flex flex-col gap-4 w-full">
    <div class="flex flex-col gap-2">
      <label for="firstName">{{ 'profile.edit.firstName' | translate }} <span class="text-red-500">*</span></label>
      <input pInputText id="firstName" formControlName="firstName" required />
      <small class="text-red-500" *ngIf="!form.controls['firstName'].valid && form.controls['firstName'].touched">{{
        getError('firstName') }}</small>
    </div>

    <div class="flex flex-col gap-2">
      <label for="lastName">{{ 'profile.edit.lastName' | translate }} <span class="text-red-500">*</span></label>
      <input pInputText id="lastName" formControlName="lastName" required />
      <small class="text-red-500" *ngIf="!form.controls['lastName'].valid && form.controls['lastName'].touched">{{
        getError('lastName') }}</small>
    </div>

    <div class="flex flex-col gap-2">
      <label for="email">{{ 'profile.edit.email' | translate }}</label>
      <input pInputText id="email" formControlName="email" disabled />
    </div>

    <div class="flex flex-col gap-2">
      <label for="companyName">{{ 'profile.edit.companyName' | translate }} <span class="text-red-500">*</span></label>
      <input pInputText id="companyName" formControlName="companyName" required />
      <small class="text-red-500" *ngIf="!form.controls['companyName'].valid && form.controls['companyName'].touched">{{
        getError('companyName') }}</small>
    </div>

    <div class="flex items-center gap-2">
      <p-checkbox binary="true" formControlName="marketingAgreement"></p-checkbox>
      <label for="marketingAgreement" class="pt-1 m-0">{{ 'profile.edit.newsletter' | translate }}</label>
    </div>


    <p-message *ngIf="editProfileError" severity="error" text="{{ editProfileError }}"></p-message>
    <p-button (onClick)="submitProfile()" [disabled]="!form.valid" [loading]="saving">{{ 'profile.edit.save' | translate }}</p-button>
  </div>
</div>